import { Link } from 'react-router-dom';
import { ArrowRight, BedDouble, Car, Compass, Plane, Route, Sparkles } from 'lucide-react';
import { useLang } from '../i18n';
import { Reveal } from './Reveal';
import { SectionHeader } from './SectionHeader';

export const PlanTripBand = () => {
  const { t } = useLang();
  const services = [
    [Plane, t('nav.flights')], [BedDouble, t('nav.stays')], [Route, t('nav.transfers')],
    [Car, t('journey.rentcar')], [Sparkles, t('nav.experiences')], [Compass, t('nav.journeys')],
  ];

  return (
    <section data-testid="plan-trip-band" className="bg-eco-green py-20 md:py-24">
      <div className="mx-auto max-w-4xl px-5 text-center md:px-8">
        <div>
          <SectionHeader
            align="center"
            dark
            eyebrow={t('journey.ecosystem.k')}
            title={t('journey.ecosystem.t')}
            text={t('journey.ecosystem.s')}
          />
          <div className="mx-auto mt-8 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-6">
            {services.map(([Icon, label]) => <div key={label} className="flex min-w-0 flex-col items-center gap-2 rounded-xl border border-white/15 bg-white/5 px-2 py-4 text-xs font-semibold text-white/80"><Icon size={18} className="text-eco-gold" /><span>{label}</span></div>)}
          </div>
          <Reveal delay={0.1}>
            <Link
              to="/build-your-journey"
              data-testid="plan-band-cta"
              className="group mt-8 inline-flex min-h-12 items-center gap-2 rounded-[10px] bg-eco-gold px-6 text-[15px] font-semibold text-eco-deep transition-colors duration-200 hover:bg-[#b8944f]"
            >
              {t('journey.build')} <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
